import * as React from 'react'
import type { SVGProps } from 'react'
const SvgTrashCanSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m5.8133 18.1996.9978-.0666zm12.3734 0 .9978.0665zM3 5c-.5523 0-1 .4477-1 1s.4477 1 1 1zm18 2c.5523 0 1-.4477 1-1s-.4477-1-1-1zm-6.0944-.7507c.1376.5348.6828.8568 1.2177.7191.5348-.1376.8568-.6828.7191-1.2177zM4.0022 6.0665l.8133 12.1996 1.9956-.1331-.8133-12.1995zM8.8067 22h6.3866v-2H8.8067zm10.3778-3.7339.8133-12.1996-1.9956-.133-.8133 12.1995zM19 5H5v2h14zM3 7h2V5H3zm16 0h2V5h-2zm-3.8067 15c2.1059 0 3.8511-1.6327 3.9912-3.7339l-1.9956-.1331c-.07 1.0506-.9426 1.867-1.9956 1.867zM4.8155 18.2661C4.9556 20.3673 6.7008 22 8.8067 22v-2c-1.053 0-1.9256-.8164-1.9956-1.867zM12 4c1.3965 0 2.5725.9551 2.9056 2.2493l1.9368-.4986C16.2874 3.5944 14.3312 2 12 2zM9.0945 6.2493C9.4275 4.955 10.6035 4 12 4V2C9.6689 2 7.7126 3.5944 7.1576 5.7507z"
    />
  </svg>
)
export default SvgTrashCanSimple
